import { Component, inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { Observable } from 'rxjs';
import { RouterLink } from '@angular/router';
import { RouteEntity } from '@core/router/route.entity';
import { LogoComponent } from '@ui/layout/logo/logo.component';
import { LangCheckerComponent } from '@ui/layout/lang-checker/lang-checker.component';
import { UserState } from '@core/state/user.state';
import { LoginResponse } from '@api/models/UserService/Contract/login-response';
import { LanguageState } from '@core/localization/language.state';
import { Language } from '@api/models/Postgres/Model/language';
import { map } from 'rxjs/operators';
import { AvailableLanguage } from '@core/localization/available-language';
import { IconBsComponent } from '@ui/elements/icon-bs/icon-bs.component';
import { BsIconTypes } from '@ui/elements/icon-bs/bs-icon-types';


@Component({
    selector: 'mon-tech-header-mon-tech',
    templateUrl: './header-mon-tech.component.html',
    styleUrls: ['./header-mon-tech.component.scss'],
    imports: [AsyncPipe, RouterLink, LogoComponent, LangCheckerComponent, IconBsComponent],
})
export class HeaderMonTechComponent {
    readonly #languageState: LanguageState = inject(LanguageState);
    readonly #userState: UserState = inject(UserState);

    public readonly routeEntity: typeof RouteEntity = RouteEntity;
    /**
     * User data
     */
    public readonly user$: Observable<LoginResponse> = this.#userState.user$;
    /**
     * List languages
     */
    public readonly languages$: Observable<Language[]> = this.#languageState.languages$;
    /**
     * Selected lang code
     */
    public readonly selectedLang$: Observable<string> = this.#languageState.language$.pipe(
        map((lang: AvailableLanguage) => lang.toUpperCase()),
    );

    public handlerChangeLang(lang: Language): void {
        this.#languageState.setCurrentLanguage(lang);
        window.location.reload();
    }

    protected readonly bsIconTypes: typeof BsIconTypes = BsIconTypes;
}
